module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("A Capital Question")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although common usage is to refer to ‘the Salvation Army’, this is not how it is known by its members. The trust deed which set up the organisation laid down that it was to be called ‘The Salvation Army’. The capitalisation of the definite article makes it part of the name so that in this way ‘Salvation’ may be seen to lay at its heart. This book will employ common usage.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5348ed6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Capital.vue
// module id = 78
// module chunks = 0